import axiosInstance from "../axiosInstance";

export const PUTCompletarAuditoriaSMA = async (payload, loggedUser) => {
  try {
    const { nombreCompleto } = loggedUser;

    const response = await axiosInstance.put(
      `${process.env.REACT_APP_WMS_BASE_URL}/auditoria-sma/operacion/${payload.id}/completar`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json, text/plain, */*",

          usuario: nombreCompleto,
        },
      },
    );

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status,
      data: error.response?.data,
      message:
        error.response?.data?.message || "Error al realizar la solicitud",
    };
  }
};

export default PUTCompletarAuditoriaSMA;
